import React from 'react';
interface PopupLinkProps {
  href: string;
  label: string;
  windowName: string;
  ariaLabel: string;
  className?: string;
}
export function PopupLink({
  href,
  label,
  windowName,
  ariaLabel,
  className = 'lowercase hover:opacity-60'
}: PopupLinkProps) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    event.preventDefault();
    const popupWidth = Math.min(960, window.screen.availWidth);
    const popupHeight = Math.min(760, window.screen.availHeight);
    const left = Math.max(0, Math.round(window.screenX + (window.outerWidth - popupWidth) / 2));
    const top = Math.max(0, Math.round(window.screenY + (window.outerHeight - popupHeight) / 2));
    const popup = window.open(href, windowName, `popup=yes,width=${popupWidth},height=${popupHeight},left=${left},top=${top},noopener,noreferrer`);
    if (popup) {
      popup.focus();
      return;
    }
    window.open(href, '_blank', 'noopener,noreferrer');
  };
  return <a href={href} target="_blank" rel="noopener noreferrer" onClick={handleClick} className={className} aria-label={ariaLabel} data-id="element-174" data-mp="1do95uq9ly7m2">
      {label}
    </a>;
}